import { axios } from 'lib/axios';

export const loginWithEmailAndPassword = (data) => {
  console.log(data);
  return axios.post('/auth/login-provider', data);
};
